export const rockyAnswers = [
  "Thanks for sharing! I'll pass this to your local HR contact!",
  "Alright, I'll let your local HR contact know!",
  'I see! Let me pass this to your local HR contact, so we work on it together!',
  'Got you! Your local HR contact will address you about this shortly!',
  'Got it. I`ll let your manager know.',
];
